import http from "utils/http";
import { digiBasic } from "constants/endpoints";

const getDigibasicTools = ({ queryParams }) => {
  const ENDPOINT = digiBasic.getDigibasicTools({ queryParams });
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.get(`${API_BASE_URL}${ENDPOINT}`);
};

export default getDigibasicTools;
